// extracted by mini-css-extract-plugin
export var actions = "_1a-0";
export var actionsContainer = "_1a-7";
export var border = "_1a-1";
export var childFullHeight = "_1a-f";
export var collapse = "_1a-2";
export var content = "_1a-a";
export var contentChild = "_1a-e";
export var fullscreen = "_1a-c";
export var hasLeftRadius = "_1a-k";
export var headerContainer = "_1a-3";
export var headerRow = "_1a-5";
export var hidePadding = "_1a-b";
export var navCollapsedGap = "_1a-l";
export var noScrollX = "_1a-m";
export var noScrollY = "_1a-n";
export var noTopPadding = "_1a-i";
export var optOutTopPadding = "_1a-d";
export var pageMain = "_1a-j";
export var pageOuter = "_1a-g";
export var pagePadding = "_1a-8";
export var pageScroll = "_1a-9";
export var profile = "_1a-o";
export var profileContainer = "_1a-p";
export var profileImage = "_1a-q";
export var profileMain = "_1a-r";
export var profileSubtitle = "_1a-t";
export var profileTitle = "_1a-s";
export var showLeftPadding = "_1a-h";
export var tabsPortalSlot = "_1a-6";
export var tabsWrapper = "_1a-4";
export var title = "_1a-u";